"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Driver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Driver = function Driver(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.004.822a10.167 10.167 0 00-8.01 0 .82.82 0 00-.318 1.267l.891 1.113.3 2.994a3.148 3.148 0 006.264 0l.3-2.994.89-1.113a.82.82 0 00-.317-1.267zM5.789 3.747l.708.212c.98.294 2.024.294 3.004 0l.708-.212-.234 2.333a1.986 1.986 0 01-3.953 0L5.79 3.747zm1.048-1.105a.58.58 0 01.58-.581H8.58a.58.58 0 110 1.161H7.418a.58.58 0 01-.58-.58z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.581 9.611a.58.58 0 00-.563.722l.29 1.161a.58.58 0 00.075.174l-.133 1.194a4.977 4.977 0 011.497 0l-.133-1.194a.58.58 0 00.075-.174l.29-1.161a.58.58 0 00-.563-.722h-.835zm6.226 5.809h-1.452a4.955 4.955 0 00-2.548-2.273l.425-3.398c.094.028.188.057.282.088l1.78.593a3.422 3.422 0 011.978 1.716l.054.11a3.178 3.178 0 010 2.842.58.58 0 01-.519.321zM5.484 9.837c.094-.03.187-.06.281-.088l.425 3.398a4.954 4.954 0 00-2.548 2.272H2.191a.58.58 0 01-.52-.32 3.178 3.178 0 010-2.844l.055-.109a3.422 3.422 0 011.979-1.716l1.78-.593zM6.902 16h2.194l-.11-.99c.537.194 1 .542 1.337.99h1.35a4.066 4.066 0 00-7.348 0h1.35c.337-.448.8-.796 1.337-.99l-.11.99z",
    fill: "currentColor"
  }));
};

exports.Driver = Driver;
var _default = Driver;
exports.default = _default;